import { DataType } from '@/util/index'
import IconPayOff from '@/assets/fonts/system-font/webfonts/icon-pay-off.svg'
import IconPayOffInN from '@/assets/fonts/system-font/webfonts/icon-pay-off-in-n.svg'
import IconPayDown from '@/assets/fonts/system-font/webfonts/icon-pay-down.svg'
import IconChangeMode from '@/assets/fonts/system-font/webfonts/icon-change-payment-mode.svg'
import IconChangeFrequency from '@/assets/fonts/system-font/webfonts/icon-change-payroll-frequency.svg'
import IconChangePayrollDay from '@/assets/fonts/system-font/webfonts/icon-change-payment-date.svg'
// const IconPayOff = '/static/fonts/system-font/webfonts/icon-pay-off.svg'
// const IconPayOffInN = '/static/fonts/system-font/webfonts/icon-pay-off-in-n.svg'
// const IconPayDown = '/static/fonts/system-font/webfonts/icon-pay-down.svg'
// const IconChangeMode = '/static/fonts/system-font/webfonts/icon-change-payment-mode.svg'
// const IconChangeFrequency = '/static/fonts/system-font/webfonts/icon-change-payroll-frequency.svg'
// const IconChangePayrollDay = '/static/fonts/system-font/webfonts/icon-change-payment-date.svg'
// import IconChangePaydayOnHoliday from '@/assets/fonts/system-font/webfonts/icon-change-payday-on-holiday.svg'
// import IconChangePaydayOnAvailable from '@/assets/fonts/system-font/webfonts/icon-change-payday-on-available.svg'
const ACTION = DataType.PaymentScheduleAction
const MULTI_PAYMENT_SCHEDULE_ACTION = {
  PAY_OFF: {
    title: ACTION.PAY_OFF.text,
    value: ACTION.PAY_OFF.value,
    iconPath: IconPayOff,
    privilegeCode: DataType.PrivilegeCode.PAY_OFF,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Pay Off Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date' },
      { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', controlType: 'select', items: { transactionMode: DataType.TransactionMode } },
      { label: 'Amount', fieldKey: 'amount', template: '{amount}', format: 'currency', disabled: true },
      { label: 'Finance Charge', fieldKey: 'interest', template: '{interest}', format: 'currency', controlType: 'checkbox-input', hasCheckboxInput: false },
      { label: 'Waived Fee', fieldKey: 'waivedFee', template: '{waivedFee}', format: 'currency', disabled: true },
      { label: 'Principal', fieldKey: 'principal', template: '{principal}', format: 'currency', disabled: true },
      { label: 'Unpaid Charge', fieldKey: 'unpaidFee', template: '{unpaidFee}', format: 'currency', disabled: false, controlType: 'checkbox-input', hasCheckboxInput: false }
    ]
  },
  PAY_OFF_IN_N: {
    title: ACTION.PAY_OFF_IN_N.text,
    value: ACTION.PAY_OFF_IN_N.value,
    iconPath: IconPayOffInN,
    privilegeCode: DataType.PrivilegeCode.PAY_OFF_IN_N,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Next Payroll Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Payroll Frequency', fieldKey: 'payrollFrequency', template: '{payrollFrequency}', controlType: 'select', disabled: true, items: { payrollFrequency: DataType.PayrollFrequency } },
      { label: '1st Monthly Payday', fieldKey: 'firstDayOfMonth', template: '{firstDayOfMonth}', controlType: 'select', items: { firstDayOfMonth: DataType.DayOfMonth31 } },
      { label: '2nd Monthly Payday', fieldKey: 'secondDayOfMonth', template: '{secondDayOfMonth}', controlType: 'select', items: { secondDayOfMonth: DataType.DayOfMonth31 } },
      { label: '1st Day of Week', fieldKey: 'firstDayOfWeek', template: '{firstDayOfWeek}', controlType: 'select', disabled: true, items: { firstDayOfWeek: DataType.FirstDayOfWeek } },
      { label: 'Finance Charge', fieldKey: 'financeCharge', template: '{financeCharge}', format: 'currency', controlType: 'checkbox-input', disabled: true, hasCheckboxInput: true },
      { label: 'Waived Fee', fieldKey: 'waivedFee', template: '{waivedFee}', format: 'currency', disabled: true },
      { label: 'Pay Off in N', fieldKey: 'debitCount', template: '{debitCount}' }
      // { label: 'Unpaid Charge', fieldKey: 'unpaidFee', template: '{unpaidFee}', format: 'currency', controlType: 'checkbox-input', hasCheckboxInput: true }
    ]
  },
  PAY_DOWN: {
    title: ACTION.PAY_DOWN.text,
    value: ACTION.PAY_DOWN.value,
    iconPath: IconPayDown,
    privilegeCode: DataType.PrivilegeCode.PAY_DOWN,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Disbursement Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', moreDate: true },
      { label: 'Add Pay Down Amount', fieldKey: 'extraPrincipal', template: '{extraPrincipal}', format: 'currency' },
      { label: 'Max Pay Down Amount', fieldKey: 'maxPayDownAmount', template: '{maxPayDownAmount}', format: 'currency', disabled: true },
      { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', controlType: 'select', items: { transactionMode: DataType.TransactionMode } }
    ]
  },
  CHANGE_MODE: {
    title: ACTION.CHANGE_MODE.text,
    value: ACTION.CHANGE_MODE.value,
    iconPath: IconChangeMode,
    privilegeCode: DataType.PrivilegeCode.CHANGE_MODE,
    fieldClass: 'lg4',
    fields: [
      { label: 'Disbursement Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date' },
      { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', controlType: 'select', items: { transactionMode: DataType.TransactionMode } }
    ]
  },
  CHANGE_FREQUENCY: {
    title: ACTION.CHANGE_FREQUENCY.text,
    value: ACTION.CHANGE_FREQUENCY.value,
    iconPath: IconChangeFrequency,
    privilegeCode: DataType.PrivilegeCode.CHANGE_FREQUENCY,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Week Day', fieldKey: 'weekDay', template: '{weekDay}', controlType: 'select', disabled: true, items: { weekDay: DataType.FirstDayOfWeek } },
      { label: 'Next Payroll Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Payroll Frequency', fieldKey: 'payrollFrequency', template: '{payrollFrequency}', controlType: 'select', items: { payrollFrequency: DataType.PayrollFrequency } },
      { label: '1st Monthly Payday', fieldKey: 'firstDayOfMonth', template: '{firstDayOfMonth}', controlType: 'select', items: { firstDayOfMonth: DataType.DayOfMonth31 } },
      { label: '2nd Monthly Payday', fieldKey: 'secondDayOfMonth', template: '{secondDayOfMonth}', controlType: 'select', items: { secondDayOfMonth: DataType.DayOfMonth31 } },
      { label: '1st Day of Week', fieldKey: 'firstDayOfWeek', template: '{firstDayOfWeek}', controlType: 'select', items: { firstDayOfWeek: DataType.FirstDayOfWeek } },
      { label: 'Last Payment Date', fieldKey: 'lastPaymentDate', template: '{lastPaymentDate}', controlType: 'select', items: { lastPaymentDate: DataType.LastPaymentDate } }
    ]
  },
  CHANGE_DATE: {
    title: ACTION.CHANGE_DATE.text,
    value: ACTION.CHANGE_DATE.value,
    iconPath: IconChangePayrollDay,
    privilegeCode: DataType.PrivilegeCode.CHANGE_DATE,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Next Payroll Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Payroll Frequency', fieldKey: 'payrollFrequency', template: '{payrollFrequency}', controlType: 'select', disabled: true, items: { payrollFrequency: DataType.PayrollFrequency } },
      { label: '1st Monthly Payday', fieldKey: 'firstDayOfMonth', template: '{firstDayOfMonth}', controlType: 'select', items: { firstDayOfMonth: DataType.DayOfMonth31 } },
      { label: '2nd Monthly Payday', fieldKey: 'secondDayOfMonth', template: '{secondDayOfMonth}', controlType: 'select', items: { secondDayOfMonth: DataType.DayOfMonth31 } },
      { label: '1st Day of Week', fieldKey: 'firstDayOfWeek', template: '{firstDayOfWeek}', controlType: 'select', disabled: true, items: { firstDayOfWeek: DataType.FirstDayOfWeek } },
      { label: 'Last Payment Date', fieldKey: 'lastPaymentDate', template: '{lastPaymentDate}', controlType: 'select', items: { lastPaymentDate: DataType.LastPaymentDate } }
    ]
  },
  REVOKE_ACH: {
    title: ACTION.REVOKE_ACH.text,
    value: ACTION.REVOKE_ACH.value,
    iconName: 'credit_card_off',
    privilegeCode: DataType.PrivilegeCode.REVOKE_ACH,
    fieldClass: 'lg4',
    limitValue: true,
    fields: [
      { label: 'Next Payroll Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' }
    ]
  },
  // PAY_FIXED_AMOUNT: {
  //   title: ACTION.PAY_FIXED_AMOUNT.text,
  //   value: ACTION.PAY_FIXED_AMOUNT.value,
  //   iconPath: IconPayOff,
  //   privilegeCode: DataType.PrivilegeCode.PAY_FIXED_AMOUNT,
  //   buttonCode: DataType.ButtonEnum.PAY_FIXED_AMOUNT.value,
  //   fieldClass: 'lg3',
  //   limitValue: true,
  //   topFields: [
  //     { label: 'Late Fee', fieldKey: 'lateFee', template: '{lateFee}' },
  //     { label: 'NSF Fee', fieldKey: 'nsfFee', template: '{nsfFee}' },
  //     { label: 'Unpaid Fee', fieldKey: 'unpaidFee', template: '{unpaidFee}' },
  //     { label: 'Finance Fee', fieldKey: 'interest', template: '{interest}' },
  //     { label: 'Principal', fieldKey: 'principal', template: '{principal}' }
  //   ],
  //   fields: [
  //     { label: 'Disbursement Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
  //     { label: 'Regular Amount', fieldKey: 'regularAmount', template: '{regularAmount}', format: 'currency' },
  //     { label: 'Payment Mode', fieldKey: 'transactionMode', template: '{transactionMode}', controlType: 'select', items: { transactionMode: DataType.TransactionMode } },
  //     { label: 'Payroll Frequency', fieldKey: 'payrollFrequency', template: '{payrollFrequency}', controlType: 'select', items: { payrollFrequency: DataType.PayrollFrequency } },
  //     { label: '1st Monthly Payday', fieldKey: 'firstDayOfMonth', template: '{firstDayOfMonth}', controlType: 'select', items: { firstDayOfMonth: DataType.DayOfMonth31 } },
  //     { label: '2nd Monthly Payday', fieldKey: 'secondDayOfMonth', template: '{secondDayOfMonth}', controlType: 'select', items: { secondDayOfMonth: DataType.DayOfMonth31 } },
  //     { label: '1st Day of Week', fieldKey: 'firstDayOfWeek', template: '{firstDayOfWeek}', controlType: 'select', items: { firstDayOfWeek: DataType.FirstDayOfWeek } },
  //     { label: 'Payday On Holiday', fieldKey: 'paydayOnHoliday', template: '{paydayOnHoliday}', controlType: 'select', items: { paydayOnHoliday: DataType.PaydayOnHolidayType } },
  //     { label: 'Payday On Availiable', fieldKey: 'paydayOnAvailable', template: '{paydayOnAvailable}', controlType: 'select', items: { paydayOnAvailable: DataType.PaydayOnAvailable } }
  //   ]
  // },
  REVOKE_WA: {
    title: ACTION.REVOKE_WA.text,
    value: ACTION.REVOKE_WA.value,
    iconName: 'swipe_left',
    privilegeCode: DataType.PrivilegeCode.REVOKE_WA,
    buttonCode: DataType.ButtonEnum.REVOKE_WA.value,
    fieldClass: 'lg4',
    limitValue: true,
    fields: []
  }
  /*
  CHANGE_PAYDAY_ON_HOLIDAY: {
    title: ACTION.CHANGE_PAYDAY_ON_HOLIDAY.text,
    value: ACTION.CHANGE_PAYDAY_ON_HOLIDAY.value,
    iconPath: IconChangePaydayOnHoliday,
    privilegeCode: DataType.PrivilegeCode.CHANGE_PAYDAY_ON_HOLIDAY,
    fieldClass: 'lg4',
    fields: [
      { label: 'Next Payroll Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Payday On Holiday', fieldKey: 'paydayOnHoliday', template: '{paydayOnHoliday}', controlType: 'select', items: { paydayOnHoliday: DataType.PaydayOnHolidayType } }
    ]
  },
  CHANGE_PAYDAY_ON_AVAILABLE: {
    title: ACTION.CHANGE_PAYDAY_ON_AVAILABLE.text,
    value: ACTION.CHANGE_PAYDAY_ON_AVAILABLE.value,
    iconPath: IconChangePaydayOnAvailable,
    privilegeCode: DataType.PrivilegeCode.CHANGE_PAYDAY_ON_AVAILABLE,
    fieldClass: 'lg4',
    fields: [
      { label: 'Next Payroll Date', fieldKey: 'effectiveDate', template: '{effectiveDate}', controlType: 'date', allowed: 'start-tomorrow no-holiday no-weekend ' },
      { label: 'Payday On Available', fieldKey: 'paydayOnAvailable', template: '{paydayOnAvailable}', controlType: 'select', items: { paydayOnAvailable: DataType.PaydayOnAvailable } }
    ]
  }
  */
}
const EDIT_PROFILE = {
  EMPLOYMENT: {
    section: {
      name: 'employment',
      caption: 'EMPLOYMENT',
      type: 'form',
      code: DataType.PrivilegeCode.EMPLOYMENT_SECTION
    },
    title: {
      template: '{employerName}',
      case: 'PROPER_CASE',
      fieldKey: 'employerName'
    },
    formFields: [
      { label: 'Employer Name', fieldKey: 'employerName', rules: 'required|specialCharacters' },
      { label: 'Job Title', fieldKey: 'jobTitle', click: true },
      { label: 'Job Type', fieldKey: 'jobType', controlType: 'v-select', options: { jobType: DataType.JobType }, click: true },
      { label: 'State', fieldKey: 'employerState', controlType: 'v-select', options: { employerState: DataType.State }, click: true },
      { label: 'Payday on Holiday', fieldKey: 'paydayOnHoliday', controlType: 'v-select', options: { paydayOnHoliday: DataType.PaydayOnHolidayType }, rules: 'required', isEditable: false },
      { label: 'VOE', fieldKey: 'voe', controlType: 'v-select', options: { voe: DataType.VoE }, rules: 'required' },
      { label: 'Work Phone', fieldKey: 'employerPhone', mask: '(###) ###-####', rules: 'required|phone' },
      { label: 'Last Payroll Date', fieldKey: 'lastPayday', controlType: 'v-date-picker', format: 'date', allowed: 'no-weekend,end-now', rules: 'required', isEditable: false },
      { label: 'Payroll Frequency', fieldKey: 'payrollFrequency', controlType: 'v-select', options: { payrollFrequency: DataType.PayrollFrequency }, rules: 'required', isEditable: false },
      { label: 'Day of Week Paid', fieldKey: 'firstDayOfWeek', controlType: 'v-select', options: { firstDayOfWeek: DataType.FirstDayOfWeek }, rules: 'required', isEditable: false },
      { label: 'First Day of Month', fieldKey: 'firstDayOfMonth', controlType: 'v-select', options: { firstDayOfMonth: DataType.DayOfMonth }, rules: 'required', isEditable: false },
      { label: 'Second Day of Month', fieldKey: 'secondDayOfMonth', controlType: 'v-select', options: { secondDayOfMonth: DataType.DayOfMonth }, click: true, isEditable: false }
    ]
  }
}
const PPS_TO_LCS_COLLECTION = {
  TO_COLLECTION: {
    title: 'To Collection',
    value: ACTION.ADJUST_AMOUNT.value,
    type: 'form',
    fields: {
      waivedBalance: {
        title: 'Waive',
        type: DataType.PaymentFeeTypeEnum.WAIVED_IN_COLLECTION.value,
        fields: [
          { label: 'Late Fee', fieldKey: 'waivedLateFee', template: '{waivedLateFee}' },
          { label: 'NSF Fee', fieldKey: 'waivedNsfFee', template: '{waivedNsfFee}' },
          { label: 'Unpaid Fee', fieldKey: 'waivedUnpaidFee', template: '{waivedUnpaidFee}' },
          { label: 'Finance Fee', fieldKey: 'waivedInterest', template: '{waivedInterest}' },
          { label: 'Principal', fieldKey: 'waivedPrincipal', template: '{waivedPrincipal}' }
        ]
      },
      leftBalance: {
        title: 'Left',
        type: DataType.PaymentFeeTypeEnum.LEFT_IN_COLLECTION.value,
        fields: [
          { label: 'Late Fee', fieldKey: 'leftLateFee', template: '{leftLateFee}', disabled: true },
          { label: 'NSF Fee', fieldKey: 'leftNsfFee', template: '{leftNsfFee}', disabled: true },
          { label: 'Unpaid Fee', fieldKey: 'leftUnpaidFee', template: '{leftUnpaidFee}', disabled: true },
          { label: 'Finance Fee', fieldKey: 'leftInterest', template: '{leftInterest}', disabled: true },
          { label: 'Principal', fieldKey: 'leftPrincipal', template: '{leftPrincipal}', disabled: true }
        ]
      },
      paidBalance: {
        title: 'Paid',
        type: DataType.PaymentFeeTypeEnum.PAID_IN_COLLECTION.value,
        fields: [
          { label: 'Late Fee', fieldKey: 'paidLateFee', template: '{paidLateFee}', disabled: true },
          { label: 'NSF Fee', fieldKey: 'paidNsfFee', template: '{paidNsfFee}', disabled: true },
          { label: 'Unpaid Fee', fieldKey: 'paidUnpaidFee', template: '{paidUnpaidFee}', disabled: true },
          { label: 'Finance Fee', fieldKey: 'paidInterest', template: '{paidInterest}', disabled: true },
          { label: 'Principal', fieldKey: 'paidPrincipal', template: '{paidPrincipal}', disabled: true }
        ]
      },
      total: {
        title: 'Total',
        type: 1,
        fields: [
          { label: 'Late Fee', fieldKey: 'totalLateFee', template: '{totalLateFee}', disabled: true },
          { label: 'NSF Fee', fieldKey: 'totalNsfFee', template: '{totalNsfFee}', disabled: true },
          { label: 'Unpaid Fee', fieldKey: 'totalUnpaidFee', template: '{totalUnpaidFee}', disabled: true },
          { label: 'Finance Fee', fieldKey: 'totalInterest', template: '{totalInterest}', disabled: true },
          { label: 'Principal', fieldKey: 'totalPrincipal', template: '{totalPrincipal}', disabled: true }
        ]
      }
    }
  }
}
export { MULTI_PAYMENT_SCHEDULE_ACTION, EDIT_PROFILE, PPS_TO_LCS_COLLECTION }
